import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Update } from "@ngrx/entity";
import { combineLatest, of } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { CriterionsTemplateModel } from "..";
import { LoadCriterionsTemplates, CriterionsTemplateActionTypes, CriterionsTemplatesLoaded } from "../_actions";
import { AddCriterionsTemplate, DeleteCriterionsTemplate, DuplicateCriterionsTemplate, CriterionsTemplateAdded, CriterionsTemplateUpdated, UpdateCriterionsTemplate } from "../_actions";
import { CriterionsTemplateService } from "../_services";

@Injectable()
export class CriterionsTemplateEffects {
    constructor(
        private actions: Actions,
        private service: CriterionsTemplateService
    ) {}

    @Effect()
    loadCriterionsTemplate$ =
        this.actions.pipe(
            ofType<LoadCriterionsTemplates>(CriterionsTemplateActionTypes.LOAD_CRITERIONS_TEMPLATES),
            mergeMap(({payload}) => {
                return this.service.getAll(payload.request)
            }),
            map(res => {
                return new CriterionsTemplatesLoaded({
                    templates: res.templates,
                    total: res.total
                });
            })
        )

    @Effect()
    addCriterionsTemplate$ =
        this.actions.pipe(
            ofType<AddCriterionsTemplate>(CriterionsTemplateActionTypes.ADD_CRITERIONS_TEMPLATE),
            mergeMap(({payload}) => {
                return this.service.create(payload.template)
            }),
            map(res => {
                return new CriterionsTemplateAdded({
                    template: res
                })
            })
        )

    @Effect()
    updateCriterionsTemplate$ =
        this.actions.pipe(
            ofType<UpdateCriterionsTemplate>(CriterionsTemplateActionTypes.UPDATE_CRITERIONS_TEMPLATE),
            mergeMap(({payload}) => {
                return this.service.update(payload.id, payload.template)
            }),
            map(res => {
                const newTemplate: Update<CriterionsTemplateModel> = {
                    id: res.id,
                    changes: {
                        ...res
                    }
                };
                return new CriterionsTemplateUpdated({
                    id: res.id,
                    template: newTemplate
                })
            })
        )

    @Effect()
    deleteCriterionsTemplate$ = 
        this.actions.pipe(
            ofType<DeleteCriterionsTemplate>(CriterionsTemplateActionTypes.DELETE_CRITERIONS_TEMPLATE),
            mergeMap(({payload}) => {
                return combineLatest([
                    this.service.delete(payload.id),
                    of({currentPage: payload.currentPage, currentPageSize: payload.currentPageSize})
                ])
            }),
            map(([res, {currentPage, currentPageSize}]) => {
                return new LoadCriterionsTemplates({
                    request: {
                        pageNumber: currentPage,
                        pageSize: currentPageSize
                    }
                })
            })
        )

    @Effect()
    duplicateCriterionsTemplate$ =
        this.actions.pipe(
            ofType<DuplicateCriterionsTemplate>(CriterionsTemplateActionTypes.DUPLICATE_CRITERIONS_TEMPLATE),
            mergeMap(({payload}) => {
                return combineLatest([
                    this.service.duplicate(payload.template),
                    of({currentPage: payload.currentPage, currentPageSize: payload.currentPageSize})
                ])
            }),
            map(([res, {currentPage, currentPageSize}]) => {
                return new LoadCriterionsTemplates({
                    request: {
                        pageNumber: currentPage,
                        pageSize: currentPageSize
                    }
                })
            })
        )
}
